import { render, staticRenderFns } from "./lkuBenefitenttl.vue?vue&type=template&id=0ec908c8"
import script from "./lkuBenefitenttl.vue?vue&type=script&lang=js"
export * from "./lkuBenefitenttl.vue?vue&type=script&lang=js"
import style0 from "./lkuBenefitenttl.vue?vue&type=style&index=0&id=0ec908c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports